module.exports = __webpack_public_path__ + "static/media/dwayne_J3.jpg_1544912576416.62cf6fe6.jpg";